import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import Footer from '../Footer';

const Layout: React.FC = () => {
  return (
    <div className="wrapper">
      <Navbar />
      <Sidebar />
      
      {/* Content Wrapper. Contains page content */}
      <div className="content-wrapper">
        <Outlet />
      </div>
      
      <Footer />
    </div>
  );
};

export default Layout;